<template>
    <div class="markettrends-chart">
        <mvtChart v-if="getChartData" :data="getChartData"></mvtChart>
        <div v-else class="no-results">
              There is no data with current selection
        </div>
    </div>
</template>
<script src="./markettrends-chart.js"></script>

<style lang="scss">
@use "./markettrends-chart.scss" as *;
</style>